import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Contact } from 'app/core/store/customer-info/customer-info.interface';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnChanges {
  @Input() contact: Contact;
  phoneNumbers: string[] = [];
  emailAddresses: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.contact) {
      this.phoneNumbers = this.contact.phoneNumber.split(';').map(phoneNumber => phoneNumber.trim());
      this.emailAddresses = this.contact.emailAddress.split(';').map(phoneNumber => phoneNumber.trim());
    } else {
      this.phoneNumbers = [];
      this.emailAddresses = [];
    }
  }
}
